export default "__VITE_ASSET__fca4c7a1__"